export const DIAGNOSIS_OPTIONS = [
  {
    index: 1,
    key: 'urticaria',
    text: 'Tem Urticária?',
    info: '"Urticas e angioedema podem ocorrer na UCE e outras doenças. Pacientes com somente urticas (sem angioedema) podem ter urticária vasculite ou doenças auto-inflamatórias como Síndrome de Schnitzler ou Síndromes periódicas associadas à criopirinas (CAPS). Pacientes com somente angioedema recorrente (sem urticas) podem ter angioedema  mediado por bradicinina, angioedema associado à enzima conversora de angiotensina (iECA) ou Angioedema hereditário (HAE). O diagnóstico diferencial é baseado na história clínica e exames complementares simples como VHS, testes sanguíneos. As perguntas aqui contidas estão baseadas no Guideline para tratamento de urticária de 2021. Zuberbier, Torsten, et al. "The international EAACI/GA²LEN/EuroGuiDerm/APAAACI guideline for the definition, classification, diagnosis, and management of urticaria." Allergy 77.3 (2022): 734-766."”',
    images: [
      { src: '/assets/urticaria.png', title: 'Urticária' },
      { src: '/assets/angioedema.png', title: 'Angioedema' },
    ],
    conditionToDisplay: function (data) {
      return true
    },
  },
  {
    index: 2,
    key: 'angioedema',
    text: 'Tem Angioedema?',
    info: '"Urticas e angioedema podem ocorrer na UCE e outras doenças. Pacientes com somente urticas (sem angioedema) podem ter urticária vasculite ou doenças auto-inflamatórias como Síndrome de Schnitzler ou Síndromes periódicas associadas à criopirinas (CAPS). Pacientes com somente angioedema recorrente (sem urticas) podem ter angioedema  mediado por bradicinina, angioedema associado à enzima conversora de angiotensina (iECA) ou Angioedema hereditário (HAE). O diagnóstico diferencial é baseado na história clínica e exames complementares simples como VHS, testes sanguíneos. As perguntas aqui contidas estão baseadas no Guideline para tratamento de urticária de 2021. Zuberbier, Torsten, et al. "The international EAACI/GA²LEN/EuroGuiDerm/APAAACI guideline for the definition, classification, diagnosis, and management of urticaria." Allergy 77.3 (2022): 734-766."”',
    images: [
      { src: '/assets/urticaria.png', title: 'Urticária' },
      { src: '/assets/angioedema.png', title: 'Angioedema' },
    ],
    conditionToDisplay: function (data) {
      return true
    },
  },
  {
    index: 3,
    key: 'febre_dor_mal_estar',
    text: 'Febre recorrente inexplicada, dor nas articulações ou ósseas, mal estar?',
    info: '',
    conditionToDisplay: function (data) {
      return data.urticaria && data.angioedema === false
    },
  },
  {
    index: 4,
    key: 'doenca_auto_inflamatoria',
    text: 'Doença auto-inflamatória?',
    info: 'Pacientes devem ser questionados sobre antecedentes familiares detalhadamente e sobre a idade de início da doença. Exames para marcadores de inflamação (Proteína C reativa, VHS); paraproteinemia em adultos; pesquisa de infiltrados neutrofílicos na biópsia de pele; pesquisa de mutação genética para síndromes febris periódicas hereditárias (ex: CAPS, Síndrome periódica hereditária associada à Criopirina) podem ser feitos se suspeita',
    conditionToDisplay: function (data) {
      return data.febre_dor_mal_estar
    },
  },
  {
    index: 5,
    key: 'urticas_24_horas',
    text: 'Urticas duram mais de 24h ou deixam pigmentação residual?',
    info: 'Quanto tempo dura uma UNICA lesão urtica?',
    conditionToDisplay: function (data) {
      return (
        data.febre_dor_mal_estar === false ||
        (data.urticaria && data.angioedema) ||
        data.doenca_auto_inflamatoria === false
      )
    },
  },
  {
    index: 6,
    key: 'vasculite_biopsia',
    text: 'Sinais de vasculite na biópsia?',
    info: 'A biópsia de pele lesional demonstra danos de pequenos vasos na papila e derme reticular e/ou depósitos fibrinóides perivasculares e intersticiais localizados sugestivos de urticária vasculite?',
    conditionToDisplay: function (data) {
      return data.urticas_24_horas
    },
  },
  {
    index: 7,
    key: 'sintomas_induziveis',
    text: 'Os sintomas são induzíveis?',
    info: 'Você consegue fazer suas lesões aparecerem?  Consegue causar suas lesões propositalmente?',
    options: {
      radios: [
        { text: 'Sim', value: 'SIM' },
        { text: 'Não', value: 'NAO' },
        { text: 'Nem sempre', value: 'NEM_SEMPRE' },
      ],
      textarea: 'Descreva quais os estímulos',
    },
    conditionToDisplay: function (data) {
      return (
        data.urticas_24_horas === false || data.angioedema_deficiencia_c1 === false || data.vasculite_biopsia === false
      )
    },
  },
  {
    index: 8,
    key: 'teste_provocacao',
    text: 'Teste de provocação causou urticas?',
    info: 'Em pacientes com suspeita de urticária induzível, testes de provocação devem ser realizados conforme a orientação do consenso internacional.',
    conditionToDisplay: function (data) {
      return data.sintomas_induziveis.value === 'SIM'
    },
  },
  {
    index: 9,
    key: 'ieca_bra_gliptinas',
    text: 'Utilizou iECA antes do episódio, BRA ou gliptinas?',
    info: 'Além do iECA, BRAs (sartanas), dipeptidyl peptidase IV inhibitors (gliptinas) e inibidores da neprilysina.',
    conditionToDisplay: function (data) {
      return data.urticaria === false && data.angioedema
    },
  },
  {
    index: 10,
    key: 'angioedema_deficiencia_c1',
    text: 'Angioedema hereditário ou angioedema adquirido por deficiência de inibidor de C1?',
    info: 'Testes de complemento C4, níveis e função de C1-INH; exames para anticorpos para C1q e C1-INH, se suspeita de AAE; fazer testes para mutações se os anteriores não forem normais mas história altamente sugestiva de angioedema hereditário.',
    conditionToDisplay: function (data) {
      return data.ieca_bra_gliptinas === false || data.melhora_parar_ieca === false
    },
  },
  {
    index: 11,
    key: 'melhora_parar_ieca',
    text: 'Lesões melhoraram depois de parar iECA?',
    info: 'Remissão deve ocorrer em poucos dias, em alguns casos pode durar até 6 meses após interromper iECA.',
    conditionToDisplay: function (data) {
      return data.ieca_bra_gliptinas
    },
  },
]
